<template>
  <div class="row">
    <div v-if="isDetails" class="col-md-12">
      <card>
        <div class="item-cnt" v-if="item">
          <h2 class="item-name"><span>{{ item.name }}</span></h2>
          <div class="item-created"><span>{{ formatDate(item.creationdate) }}</span></div>
          <div class="item-attachments">
            <div class="item-attachment" v-for="attachment in item.attachments" @click="download(attachment)">
                  <span class="item-attachment-icon">
                    <i :style="`color: ${fileIconColor(attachment.filename)}`" :class="`fas ${attachment.downloading ? 'fa-circle-notch fa-spin' : getFileIcon(attachment.contenttype)}`"></i>
                  </span>
              <span>{{attachment.filename}}</span>
              <span>&nbsp;({{humanFileSize(attachment.size | 0)}})</span>
            </div>
          </div>
          <div :class="`item-header ${item.loaded ? 'fixed-height' : ''}`" v-if="headerImageBaseUrl && !item.noPngImage">
            <img :src="`${headerImageBaseUrl}/${item.ID}.png`" width="100%" @load="showImage(item)" @error="hideImage(item, 'noPngImage')"/>
          </div>
          <div :class="`item-header ${item.loaded ? 'fixed-height' : ''}`" v-if="headerImageBaseUrl && item.noPngImage && !item.noJpegImage">
            <img :src="`${headerImageBaseUrl}/${item.ID}.jpg`" width="100%" @load="showImage(item)" @error="hideImage(item, 'noJpegImage')"/>
          </div>
          <div v-html="item.body"></div>
        </div>
        <div v-else>
          <loader title="Infothek.loading"></loader>
        </div>
      </card>
    </div>
    <template v-else>
      <div :class="hasCategories ? `col-md-10 col-xs-8` : `col-md-12`">
        <div v-if="items == null" class="col-md-12">
          <loader title="Infothek.loading"></loader>
        </div>
        <div v-else-if="!items.length" class="col-md-12">
          <card>
            <div>{{ $t('Infothek.noContent') }}</div>
          </card>
        </div>
        <div v-else v-for="item in items" :class="contentBoxClasses">
          <card class="note-card">
            <div class="item-cnt">
              <div class="item-name" @click="$parent.openView($parent.currentView, tag, item.ID.toString())"><span>{{ item.name }}</span></div>
              <div class="item-created"><span>{{ formatDate(item.creationdate) }}</span></div>
              <div :class="`item-header ${item.loaded ? 'fixed-height' : ''}`" v-if="headerImageBaseUrl && !item.noPngImage">
                <img :src="`${headerImageBaseUrl}/${item.ID}.png`" width="100%" @load="showImage(item)"  @error="hideImage(item, 'noPngImage')"/>
              </div>
              <div :class="`item-header ${item.loaded ? 'fixed-height' : ''}`" v-if="headerImageBaseUrl && item.noPngImage && !item.noJpegImage">
                <img :src="`${headerImageBaseUrl}/${item.ID}.jpg`" width="100%" @load="showImage(item)"  @error="hideImage(item, 'noJpegImage')"/>
              </div>
              <div v-if="item.description" class="item-description">
                <div class="pa-3 caption">{{ item.description }}</div>
              </div>
              <div class="item-tags">
                <span
                  class="item-tag"
                  v-if="Array.isArray(item.tags)"
                  v-for="tag in item.tags"
                  :style="`background-color:${getTagColor(tag)}`"
                >{{ $t(getTagTitle(tag)) }}</span>
              </div>
            </div>
          </card>
        </div>
      </div>
      <div v-if="hasCategories" class="col-md-2 col-xs-4">
        <div v-for="category in categories"><a :class="`category ${category.tag === tag ? 'active' : ''}`" href="javascript: void 0" @click="$parent.openView($parent.currentView, category.tag)">{{$t(category.title)}}</a></div>
      </div>
    </template>
  </div>
</template>
<script>
import { saveAs } from 'file-saver'

var view = require('../view.js'),
    viewData = {
      items: null,
      item: null,
      categories: []
    },
    resetData = Object.assign({}, viewData);

export default view(viewData, {
  props: {
    locale: String
  },
  watch: {
    locale(){
      this.reload();
    }
  },
  computed: {
    content() {
      return this.$root.getLocaleProperty('infothek');
    },

    isDetails() {
      return this.$parent.viewParam != null;
    },

    tag() {
      return (this.$parent.viewIndex || 'Infothek').replaceAll('~', '/');
    },

    hasCategories() {
      return this.categories.length
    },

    headerImageBaseUrl() {
      return this.$root.infothekHeaderImageBaseUrl ?? null;
    },

    contentBoxClasses() {
      return this.$root.infothekContentBoxClasses || 'col-xs-12';
    }
  },
  mounted() {
    this.categories = this.$root.infothekCategories || []

    this.reload();
  },
  methods: {
    reload() {
      this.items = null;

      if (this.isDetails) {
        this.$parent.setPrevious('infothek', this.$parent.viewIndex)

        this.$http.get(this.$root.url + 'note/' + this.$parent.viewParam).then(
            response => {
              this.item = response.body.result;
              this.$forceUpdate();
            },
            response => {
              console.error('Fail', response);

              this.item = {
                body: response.body.error
              };
            });

        return;
      }

      this.item = null;

      const params = {
        locale: this.locale,
        tag: this.tag
      }

      this.$http.get(this.$root.url + 'note?' + Object.entries(params).map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`).join('&')).then(
          response => {
            this.items = response.body.result.data;
            this.$forceUpdate();
          },
          response => {
            console.error('Fail', response);


          });
    },
    download(attachment) {
      attachment.downloading = true;
      const params = { responseType: 'arraybuffer' }; // or { responseType: 'blob' }
      this.$http.get(this.$root.url + 'note/' + this.item.ID + '/' + attachment.filename, params).then(
        response => {
          const blob = new Blob([response.body], {type: attachment.contenttype});
          saveAs(blob, attachment.filename);
          delete attachment.downloading;
          this.$forceUpdate();
        },
        response => {
          console.error('Fail', response);
        });

      this.$forceUpdate();
    },
    hideImage(item, prop = noImage){
      item[prop] = true;
      this.$forceUpdate();
    },
    showImage(img) {
      img.loaded = true;
      this.$forceUpdate();
    },
    getTagColor(tag) {
      return (this.categories.find(x => tag === x.tag) || {}).color || 'transparent';
    },
    getTagTitle(tag) {
      return (this.categories.find(x => tag === x.tag) || {}).title || tag;
    },
    getFileIcon(contenttype) {
      const [mime, type] = contenttype.split('/');
      switch (mime) {
        // Media
        case 'image':
          return 'fa-file-image';
        case 'audio':
          return 'fa-file-audio';
        case 'video':
          return 'fa-file-video';

        case 'text':
          switch (type) {
            case 'html':
              return 'fa-file-code';
            default:
              return 'fa-file-text';
          }

        case 'application':
          switch (type) {
            case 'pdf':
              return 'fa-file-pdf';

            case 'msword':
            case 'vnd.ms-word':
            case 'vnd.oasis.opendocument.text':
            case 'vnd.openxmlformats-officedocument.wordprocessingml':
              return 'fa-file-word';

            case 'vnd.ms-excel':
            case 'vnd.openxmlformats-officedocument.spreadsheetml':
            case 'vnd.oasis.opendocument.spreadsheet':
              return 'fa-file-excel';

            case 'vnd.ms-powerpoint':
            case 'vnd.openxmlformats-officedocument.presentationml':
            case 'vnd.oasis.opendocument.presentation':
              return 'fa-file-powerpoint';

            case 'json':
              return 'fa-file-code';

            case 'gzip':
            case 'zip':
            case 'x-zip-compressed':
              return 'fa-file-archive';
          }
      }

      return 'fa-file-download';
    },
    humanFileSize(bytes) {
      const thresh = 1024;
      if(Math.abs(bytes) < thresh) {
        return bytes + ' B';
      }
      const units = ['kB','MB','GB','TB','PB','EB','ZB','YB'];
      let u = -1;
      do {
        bytes /= thresh;
        ++u;
      } while(Math.abs(bytes) >= thresh && u < units.length - 1);

      return bytes.toFixed(1) + ' ' + units[u];
    },
    fileIconColor(extension) {
      extension = extension.split('.').pop();
      switch (extension.toLowerCase()) {
        case 'zip':
        case 'rar':
          return '#ACACAC';
        case 'rtf':
        case 'doc':
        case 'docx':
          return '#307CF1';
        case 'xls':
        case 'xlsx':
          return '#0F9D58';
        case 'stl':
          return '#D24726';
        case 'pdf':
          return '#E13D34';
        case 'txt':
          return '#5EB533';
        case 'mp3':
        case 'wma':
        case 'm4a':
        case 'flac':
          return '#8E44AD';
        case 'mp4':
        case 'wmv':
        case 'mov':
        case 'avi':
        case 'mkv':
          return '#7A3CE7';
        case 'bmp':
        case 'jpg':
        case 'jpeg':
        case 'gif':
        case 'png':
          return '#F4B400';
        default:
          var hash = 0,
            str = extension;
          for (var i = 0; i < str.length; i++) {
            hash = str.charCodeAt(i) + ((hash << 5) - hash);
          }
          return '#' + hash;
      }
    },
    formatDate(sec) {
      return new Date(sec * 1000).toLocaleDateString(
        this.locale, {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
        })
    },
  }
});
</script>
<style>
  .note-card {
    margin-bottom: 16px;
  }
  .item-name {
    font-weight: bold;
    cursor: pointer;
  }
  .item-tag {
    display: inline-block;
    margin-right: 4px;
    background-color: silver;
    padding: 2px 8px;
    border-radius: 16px;
    font-size: 11px
  }
  .item-created {
    color: gray;
    font-size: 12px
  }
  .item-description {
    margin-top: 8px;
  }
  .item-cnt {
    /*cursor: pointer;*/
  }
  .item-attachments {
    padding: 16px
  }
  .item-attachment {
    cursor: pointer;
    display: inline-block;
    margin: 0 8px 8px 0;
  }
  .item-attachment-icon {
    display: inline-block;
    min-width: 32px;
    vertical-align: middle;
    text-align: center;
    margin-bottom: 4px;
  }
  .tag-icon {
    border-radius: 50%;
    display: inline-block;
    width: 24px;
    height: 24px;
  }
  .tag-tile-action {
    min-width: 32px;
  }
  .active * {
    font-weight: bold;
  }

  .category {
    font-size: 1.3em;
    color: white;
  }

  .category.active {
    font-weight: bold;
  }

  .fixed-height {
    overflow: hidden;
  }

  .fixed-height::before {
    content: " ";
    width: 1px;
    margin-left: -1px;
    float: left;
    height: 0;
    padding-top: 56.25%;
  }

  .item-header {
    height: 0;
  }

  .item-header.fixed-height {
    height: auto;
  }

  .item-header img {
    object-fit: cover;
    vertical-align: middle;
    height: 1px;
  }

  .item-header.fixed-height img {
    height: auto;
  }
</style>
